import { history } from './../Store';
import { AppThunkAction, AppThunkDispatch } from './../app.types';
import { createEmptyProjectFromMapId } from '../../services/ProjectService';
import { Project } from '../projects/projects.types';
import {
	Comparison,
	ComparisonAction,
	ComparisonIndexAction,
	ComparisonProjectsAction
} from './comparison.types';
import {
	copyProjectComparison,
	createProjectComparison,
	getProjectComparison,
	updateProjectComparison
} from '../../services/ProjectComparisonService';
import produce from 'immer';

export const COMPARISON_LOAD_EMPTY: string = 'COMPARISON_LOAD_EMPTY';
export const COMPARISON_LOAD: string = 'COMPARISON_LOAD';
export const COMPARISON_FETCH: string = 'COMPARISON_FETCH';
export const COMPARISON_ADD_MAP: string = 'COMPARISON_ADD_MAP';
export const COMPARISON_REMOVE_MAP: string = 'COMPARISON_REMOVE_MAP';
export const COMPARISON_SET_PROJECTS: string = 'COMPARISON_SET_PROJECTS';
export const COMPARISON_SET_PROJECTS_FROM_SELECTED: string =
	'COMPARISON_SET_PROJECTS_FROM_SELECTED';
export const COMPARISON_SAVE: string = 'COMPARISON_SAVE';
export const COMPARISON_UPDATE: string = 'COMPARISON_UPDATE';
export const COMPARISON_CLEAR: string = 'COMPARISON_CLEAR';
export const COMPARISON_COPY: string = 'COMPARISON_COPY';

export function comparisonLoadEmpty(
	project: Project,
	selectedProjects: Project[],
	profileId: string
): ComparisonAction {
	const projects: Project[] = [project, ...selectedProjects];

	const comparison: Comparison = {
		projects,
		bundles: [],
		profileId
	};

	return { type: COMPARISON_LOAD_EMPTY, payload: comparison };
}

export function comparisonFetch(
	comparisonId: string
): AppThunkAction<void, ComparisonAction> {
	return async (dispatch: AppThunkDispatch<ComparisonAction>) => {
		dispatch({ type: COMPARISON_FETCH });
		const comparison: Comparison = await getProjectComparison(comparisonId);
		dispatch(comparisonLoad(comparison));
	};
}

export function comparisonRemoveMap(index: number): ComparisonIndexAction {
	return { type: COMPARISON_REMOVE_MAP, payload: index };
}

export function comparisonSetProjects(
	projects: Project[]
): ComparisonProjectsAction {
	return { type: COMPARISON_SET_PROJECTS, payload: projects };
}

export function comparisonSetProjectsFromSelected(
	mapId: string,
	selectedMaps: string[]
): ComparisonProjectsAction {
	const maps: string[] = [mapId, ...selectedMaps];
	const projects: Project[] = maps.map(createEmptyProjectFromMapId);

	return comparisonSetProjects(projects);
}

export function comparisonSave(
	comparison: Comparison,
	brandName: string,
	navigateBack?: boolean
): AppThunkAction<void, ComparisonAction> {
	return async (dispatch: AppThunkDispatch<ComparisonAction>) => {
		dispatch({ type: COMPARISON_SAVE });
		const comparisonId: string = await createProjectComparison(
			comparison,
			brandName
		);
		const updatedComparison: Comparison = produce(
			comparison,
			(draft: Comparison) => {
				draft.id = comparisonId;
			}
		);
		navigateBack
			? updatedComparison.projects[0].id
				? history.push(`/project/${updatedComparison.projects[0].id}`)
				: history.push(
						`/map/${updatedComparison.projects[0].metaDataId}`
				  )
			: history.push(`/comparison/${comparisonId}`);

		dispatch(comparisonLoad(updatedComparison));
	};
}

export function comparisonCopy(
	comparison: Comparison,
	brandName: string
): AppThunkAction<void, ComparisonAction> {
	return async (dispatch: AppThunkDispatch<ComparisonAction>) => {
		dispatch({
			type: COMPARISON_COPY
		});
		const comparisonId: string = await copyProjectComparison(
			comparison,
			brandName
		);
		const newComparison: Comparison = await getProjectComparison(
			comparisonId
		);

		history.replace(`/comparison/${comparisonId}`);

		dispatch(comparisonLoad(newComparison));
	};
}

export function comparisonUpdate(
	comparison: Comparison
): AppThunkAction<void, ComparisonAction> {
	return async (dispatch: AppThunkDispatch<ComparisonAction>) => {
		dispatch({ type: COMPARISON_UPDATE });
		await updateProjectComparison(comparison);
		dispatch(comparisonLoad(comparison));
	};
}

export function comparisonLoad(comparison: Comparison): ComparisonAction {
	return { type: COMPARISON_LOAD, payload: comparison };
}

export function comparisonClear(): ComparisonAction {
	return { type: COMPARISON_CLEAR };
}
